export default __webpack_public_path__ + "static/media/user-shape.2258a834.svg";